import { AccountType } from "component-library";

export enum AccessType {
  Full,
  Nudge,
  ReadOnly,
}

export interface IUserAgency {
  agencyId: number;
  agencyName: string;
}

export interface IUser {
  id: string;
  type: AccountType;
  email: string;
  forenames: string;
  surname: string;
  restrictAccess: boolean;
  performerAccessType?: AccessType;
  agencyList?: IUserAgency[];
}
